var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-steps",
        {
          staticClass: "is-underline",
          attrs: {
            space: 200,
            active: _vm.step,
            "finish-status": "success",
            "align-center": "",
          },
        },
        [
          _c("el-step", {
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        class: _vm.canGoToStep(0) ? "cursor-pointer" : "",
                        on: {
                          click: function ($event) {
                            return _vm.goToStep(0)
                          },
                        },
                      },
                      [
                        _vm.canGoToStep(0)
                          ? _c("i", { staticClass: "el-icon-arrow-right" })
                          : _vm._e(),
                        _vm._v(" Company Detail "),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-step", {
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        class: _vm.canGoToStep(1) ? "cursor-pointer" : "",
                        on: {
                          click: function ($event) {
                            return _vm.goToStep(1)
                          },
                        },
                      },
                      [
                        _vm.canGoToStep(1)
                          ? _c("i", { staticClass: "el-icon-arrow-right" })
                          : _vm._e(),
                        _vm._v(" Contacts "),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-step", {
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        class: _vm.canGoToStep(2) ? "cursor-pointer" : "",
                        on: {
                          click: function ($event) {
                            return _vm.goToStep(2)
                          },
                        },
                      },
                      [
                        _vm.canGoToStep(2)
                          ? _c("i", { staticClass: "el-icon-arrow-right" })
                          : _vm._e(),
                        _vm._v(" Upload Document "),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-step", {
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        class: _vm.canGoToStep(4) ? "cursor-pointer" : "",
                        on: {
                          click: function ($event) {
                            return _vm.goToStep(4)
                          },
                          dblclick: function ($event) {
                            return _vm.debugMode()
                          },
                        },
                      },
                      [
                        _vm.canGoToStep(4)
                          ? _c("i", { staticClass: "el-icon-arrow-right" })
                          : _vm._e(),
                        _vm._v(" Preview "),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isLoading,
              expression: "isLoading",
            },
          ],
        },
        [
          _vm.step === 0
            ? _c(
                "div",
                { staticClass: "my-2" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "mainForm",
                      staticClass: "compact",
                      attrs: { model: _vm.row, rules: _vm.rules },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { lg: "6" } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Company Name (Invoice)"),
                                    prop: "companyName",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { size: "small", maxlength: "255" },
                                    model: {
                                      value: _vm.row.companyName,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.row, "companyName", $$v)
                                      },
                                      expression: "row.companyName",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Company Name (System)"),
                                    prop: "companyNameInternal",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { size: "small", maxlength: "255" },
                                    model: {
                                      value: _vm.row.companyNameInternal,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.row,
                                          "companyNameInternal",
                                          $$v
                                        )
                                      },
                                      expression: "row.companyNameInternal",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Company Address"),
                                    prop: "companyAddress",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { size: "small", maxlength: "255" },
                                    model: {
                                      value: _vm.row.companyAddress,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.row, "companyAddress", $$v)
                                      },
                                      expression: "row.companyAddress",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("BR Number (For HK Company)"),
                                    prop: "brNumber",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { size: "small", maxlength: "32" },
                                    model: {
                                      value: _vm.row.brNumber,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.row, "brNumber", $$v)
                                      },
                                      expression: "row.brNumber",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Company Type"),
                                    prop: "companyType",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "mt-2" },
                                    [
                                      _c(
                                        "el-radio",
                                        {
                                          attrs: { label: "External" },
                                          model: {
                                            value: _vm.row.companyType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.row,
                                                "companyType",
                                                $$v
                                              )
                                            },
                                            expression: "row.companyType",
                                          },
                                        },
                                        [_vm._v("External")]
                                      ),
                                      _c(
                                        "el-radio",
                                        {
                                          attrs: { label: "InterCom" },
                                          model: {
                                            value: _vm.row.companyType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.row,
                                                "companyType",
                                                $$v
                                              )
                                            },
                                            expression: "row.companyType",
                                          },
                                        },
                                        [_vm._v("InterCom")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Payment Terms (Days)"),
                                    prop: "paymentTermDays",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      size: "small",
                                      type: "number",
                                      min: "0",
                                      max: "3650",
                                    },
                                    model: {
                                      value: _vm.row.paymentTermDays,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.row,
                                          "paymentTermDays",
                                          $$v
                                        )
                                      },
                                      expression: "row.paymentTermDays",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Key Account"),
                                    prop: "keyAccount",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { size: "small", maxlength: "255" },
                                    model: {
                                      value: _vm.row.keyAccount,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.row, "keyAccount", $$v)
                                      },
                                      expression: "row.keyAccount",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: _vm.$t("Contract End Date") },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      size: "small",
                                      placeholder: "YYYY-MM-DD",
                                    },
                                    model: {
                                      value: _vm.row.contractEndDate,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.row,
                                          "contractEndDate",
                                          $$v
                                        )
                                      },
                                      expression: "row.contractEndDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: _vm.$t("Contract Inactive") },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { clear: "both" } },
                                    [
                                      _c("el-checkbox", {
                                        attrs: { size: "small" },
                                        model: {
                                          value: _vm.row.contractEndInactive,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.row,
                                              "contractEndInactive",
                                              $$v
                                            )
                                          },
                                          expression: "row.contractEndInactive",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { lg: "6" } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("ERP Account Code"),
                                    prop: "accountCode",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { size: "small", maxlength: "32" },
                                    on: { input: _vm.validateAccountCode },
                                    model: {
                                      value: _vm.row.accountCode,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.row, "accountCode", $$v)
                                      },
                                      expression: "row.accountCode",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Country Code"),
                                    prop: "country",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { size: "small", maxlength: "4" },
                                    model: {
                                      value: _vm.row.country,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.row, "country", $$v)
                                      },
                                      expression: "row.country",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "Corporate Registration Number"
                                    ),
                                    prop: "corporateRegistrationNumber",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { size: "small", maxlength: "64" },
                                    model: {
                                      value:
                                        _vm.row.corporateRegistrationNumber,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.row,
                                          "corporateRegistrationNumber",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "row.corporateRegistrationNumber",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Contract Type"),
                                    prop: "contractType",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { size: "small", maxlength: "32" },
                                    model: {
                                      value: _vm.row.contractType,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.row, "contractType", $$v)
                                      },
                                      expression: "row.contractType",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Default Currency Code"),
                                    prop: "paymentCurrency",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { size: "small", maxlength: "3" },
                                    model: {
                                      value: _vm.row.paymentCurrency,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.row,
                                          "paymentCurrency",
                                          $$v
                                        )
                                      },
                                      expression: "row.paymentCurrency",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Tags"),
                                    prop: "tags",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { size: "small" },
                                    model: {
                                      value: _vm.row.tags,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.row, "tags", $$v)
                                      },
                                      expression: "row.tags",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("ICP Number"),
                                    prop: "keyAccount",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { size: "small", maxlength: "32" },
                                    model: {
                                      value: _vm.row.icpNumber,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.row, "icpNumber", $$v)
                                      },
                                      expression: "row.icpNumber",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("Contract End Alert Emails"),
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      size: "small",
                                      placeholder:
                                        "Email addresses separated by ,",
                                    },
                                    model: {
                                      value: _vm.row.contractEndAlertEmails,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.row,
                                          "contractEndAlertEmails",
                                          $$v
                                        )
                                      },
                                      expression: "row.contractEndAlertEmails",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: _vm.$t("Credit Limit") } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      size: "small",
                                      type: "number",
                                      min: "0",
                                    },
                                    model: {
                                      value: _vm.row.creditAmount,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.row, "creditAmount", $$v)
                                      },
                                      expression: "row.creditAmount",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: _vm.$t("Deposit") } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      size: "small",
                                      type: "number",
                                      min: "0",
                                    },
                                    model: {
                                      value: _vm.row.deposit,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.row, "deposit", $$v)
                                      },
                                      expression: "row.deposit",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.step === 1
            ? _c(
                "div",
                { staticClass: "my-2" },
                [
                  _c(
                    "h3",
                    [
                      _vm._v(" Company Contacts "),
                      _c(
                        "el-button",
                        {
                          staticClass: "float-right",
                          attrs: { size: "mini", type: "success" },
                          on: {
                            click: function ($event) {
                              return _vm.addCompanyContact()
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "el-icon-plus" }),
                          _vm._v(" Add Company Contact"),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._l(_vm.row.companyContacts, function (companyContact, k) {
                    return _c(
                      "el-card",
                      { key: "cc" + k, staticClass: "box-card mb-2" },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { lg: "3" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: { label: _vm.$t("Name") },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "label",
                                          fn: function (scope) {
                                            return [
                                              companyContact.isRequired
                                                ? _c(
                                                    "span",
                                                    { staticClass: "required" },
                                                    [_vm._v("*")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.$t("Name")) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        size: "small",
                                        maxlength: "255",
                                      },
                                      model: {
                                        value: companyContact.name,
                                        callback: function ($$v) {
                                          _vm.$set(companyContact, "name", $$v)
                                        },
                                        expression: "companyContact.name",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { lg: "3" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: { label: _vm.$t("Phone") },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "label",
                                          fn: function (scope) {
                                            return [
                                              companyContact.isRequired
                                                ? _c(
                                                    "span",
                                                    { staticClass: "required" },
                                                    [_vm._v("*")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.$t("Phone")) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { size: "small", maxlength: "32" },
                                      model: {
                                        value: companyContact.phone,
                                        callback: function ($$v) {
                                          _vm.$set(companyContact, "phone", $$v)
                                        },
                                        expression: "companyContact.phone",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { lg: "3" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: { label: _vm.$t("Email") },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "label",
                                          fn: function (scope) {
                                            return [
                                              companyContact.isRequired
                                                ? _c(
                                                    "span",
                                                    { staticClass: "required" },
                                                    [_vm._v("*")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.$t("Email")) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        type: "email",
                                        size: "small",
                                        maxlength: "255",
                                      },
                                      model: {
                                        value: companyContact.email,
                                        callback: function ($$v) {
                                          _vm.$set(companyContact, "email", $$v)
                                        },
                                        expression: "companyContact.email",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { lg: "1" } },
                              [
                                !companyContact.isRequired && !companyContact.id
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "mt-1",
                                        attrs: { type: "danger" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeCompanyContact(k)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-delete",
                                        }),
                                        _vm._v(" Remove"),
                                      ]
                                    )
                                  : _vm._e(),
                                !companyContact.isRequired && companyContact.id
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "mt-1",
                                        attrs: { type: "danger" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeCompanyContactRemote(
                                              k,
                                              companyContact
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-delete",
                                        }),
                                        _vm._v(" Remove"),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _c("hr"),
                  _c(
                    "h3",
                    [
                      _vm._v(" F&A Contacts "),
                      _c(
                        "el-button",
                        {
                          staticClass: "float-right",
                          attrs: { size: "mini", type: "success" },
                          on: {
                            click: function ($event) {
                              return _vm.addFaContact()
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "el-icon-plus" }),
                          _vm._v(" Add F&A Contact"),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._l(_vm.row.faContacts, function (faContact, k) {
                    return _c(
                      "el-card",
                      { key: "fc-" + k },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { lg: "3" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: { label: _vm.$t("Name") },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "label",
                                          fn: function (scope) {
                                            return [
                                              faContact.isRequired
                                                ? _c(
                                                    "span",
                                                    { staticClass: "required" },
                                                    [_vm._v("*")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.$t("Name")) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        size: "small",
                                        maxlength: "255",
                                      },
                                      model: {
                                        value: faContact.name,
                                        callback: function ($$v) {
                                          _vm.$set(faContact, "name", $$v)
                                        },
                                        expression: "faContact.name",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { lg: "3" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: { label: _vm.$t("Phone") },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "label",
                                          fn: function (scope) {
                                            return [
                                              faContact.isRequired
                                                ? _c(
                                                    "span",
                                                    { staticClass: "required" },
                                                    [_vm._v("*")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.$t("Phone")) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { size: "small", maxlength: "32" },
                                      model: {
                                        value: faContact.phone,
                                        callback: function ($$v) {
                                          _vm.$set(faContact, "phone", $$v)
                                        },
                                        expression: "faContact.phone",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { lg: "3" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: { label: _vm.$t("Email") },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "label",
                                          fn: function (scope) {
                                            return [
                                              faContact.isRequired
                                                ? _c(
                                                    "span",
                                                    { staticClass: "required" },
                                                    [_vm._v("*")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.$t("Email")) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        type: "email",
                                        size: "small",
                                        maxlength: "255",
                                      },
                                      model: {
                                        value: faContact.email,
                                        callback: function ($$v) {
                                          _vm.$set(faContact, "email", $$v)
                                        },
                                        expression: "faContact.email",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { lg: "1" } },
                              [
                                !faContact.isRequired && !faContact.id
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "mt-1",
                                        attrs: { type: "danger" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeFaContact(k)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-delete",
                                        }),
                                        _vm._v(" Remove"),
                                      ]
                                    )
                                  : _vm._e(),
                                !faContact.isRequired && faContact.id
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "mt-1",
                                        attrs: { type: "danger" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeFaContactRemote(
                                              k,
                                              faContact
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-delete",
                                        }),
                                        _vm._v(" Remove"),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm.step === 2
            ? _c(
                "div",
                { staticClass: "my-2" },
                _vm._l(_vm.row.documents, function (document, k) {
                  return _c(
                    "el-card",
                    { key: k, staticClass: "mb-2" },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { lg: "2" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: { label: _vm.$t("Document Type") },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function (scope) {
                                          return [
                                            document.isRequired
                                              ? _c(
                                                  "span",
                                                  { staticClass: "required" },
                                                  [_vm._v("*")]
                                                )
                                              : _vm._e(),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("Document Type")
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        size: "small",
                                        placeholder: "Select",
                                      },
                                      model: {
                                        value: document.type,
                                        callback: function ($$v) {
                                          _vm.$set(document, "type", $$v)
                                        },
                                        expression: "document.type",
                                      },
                                    },
                                    _vm._l(
                                      _vm.documentTypeOptions,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.code,
                                          attrs: {
                                            label: item.label,
                                            value: item.label,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { lg: "4" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: _vm.$t("Description") } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      size: "small",
                                      maxlength: "500",
                                      placeholder: "Document description",
                                    },
                                    model: {
                                      value: document.description,
                                      callback: function ($$v) {
                                        _vm.$set(document, "description", $$v)
                                      },
                                      expression: "document.description",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { lg: "1" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: " " } },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      model: {
                                        value: document.isSubsequentDocument,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            document,
                                            "isSubsequentDocument",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "document.isSubsequentDocument",
                                      },
                                    },
                                    [_vm._v("Subsequent")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { lg: "3" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: _vm.$t("File") } },
                                [
                                  document.clientFilename !== null
                                    ? _c(
                                        "el-button",
                                        {
                                          staticClass: "text-ellipsis-button",
                                          attrs: { size: "small" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openDocument(document)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(document.clientFilename)
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  document.clientFilename === null
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: { size: "small" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.uploadDocument(k)
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-upload2",
                                          }),
                                          _vm._v(" Upload"),
                                        ]
                                      )
                                    : _vm._e(),
                                  document.clientFilename !== null
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "info",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.uploadDocument(k)
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-refresh",
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { lg: "2" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: " " } },
                                [
                                  _c(
                                    "el-badge",
                                    {
                                      staticClass: "action-badge",
                                      attrs: {
                                        value:
                                          _vm.getTotalActionAttachments(
                                            document
                                          ),
                                        hidden:
                                          _vm.getTotalActionAttachments(
                                            document
                                          ) === 0,
                                      },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openActionsModal(k)
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-s-operation",
                                          }),
                                          _vm._v(" Actions"),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  document.id
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "info",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openShareModal(
                                                k,
                                                document
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-share",
                                          }),
                                          _vm._v(" Share"),
                                        ]
                                      )
                                    : _vm._e(),
                                  !document.id
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "danger",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.removeDocument(k)
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-delete",
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                  document.id
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "danger",
                                            size: "small",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.removeDocumentRemote(
                                                k,
                                                document
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-delete",
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { lg: "2" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: _vm.$t("Document Number") } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      size: "small",
                                      maxlength: "255",
                                      placeholder: "Auto-generated if empty",
                                    },
                                    model: {
                                      value: document.documentNumber,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          document,
                                          "documentNumber",
                                          $$v
                                        )
                                      },
                                      expression: "document.documentNumber",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { lg: "2" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: _vm.$t("Box File No") } },
                                [
                                  _c("el-input", {
                                    attrs: { size: "small", maxlength: "255" },
                                    model: {
                                      value: document.boxFileNo,
                                      callback: function ($$v) {
                                        _vm.$set(document, "boxFileNo", $$v)
                                      },
                                      expression: "document.boxFileNo",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { lg: "2" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: { label: _vm.$t("Client Code(DOC)") },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      size: "small",
                                      maxlength: "255",
                                      placeholder: "Client Code for Document",
                                    },
                                    model: {
                                      value: document.clientCodeDoc,
                                      callback: function ($$v) {
                                        _vm.$set(document, "clientCodeDoc", $$v)
                                      },
                                      expression: "document.clientCodeDoc",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { lg: "2" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: _vm.$t("Date of Issue") } },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      size: "small",
                                      type: "date",
                                      "value-format": "yyyy-MM-dd",
                                      placeholder: "YYYY-MM-DD",
                                    },
                                    model: {
                                      value: document.dateOfIssue,
                                      callback: function ($$v) {
                                        _vm.$set(document, "dateOfIssue", $$v)
                                      },
                                      expression: "document.dateOfIssue",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { lg: "2" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: _vm.$t("Date of Expiry") } },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      size: "small",
                                      type: "date",
                                      "value-format": "yyyy-MM-dd",
                                      placeholder: "YYYY-MM-DD",
                                    },
                                    model: {
                                      value: document.dateOfExpiry,
                                      callback: function ($$v) {
                                        _vm.$set(document, "dateOfExpiry", $$v)
                                      },
                                      expression: "document.dateOfExpiry",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { lg: "2" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: _vm.$t("PIC") } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        size: "small",
                                        placeholder: "Select",
                                        filterable: "",
                                        clearable: "",
                                      },
                                      model: {
                                        value: document.handleByUser,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            document,
                                            "handleByUser",
                                            $$v
                                          )
                                        },
                                        expression: "document.handleByUser",
                                      },
                                    },
                                    _vm._l(_vm.usersList, function (user) {
                                      return _c("el-option", {
                                        key: user.id,
                                        attrs: {
                                          label: user.name,
                                          value: String(user.id),
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { lg: "2" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t("PIC (for notification)"),
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        size: "small",
                                        placeholder: "Select users",
                                        filterable: "",
                                        clearable: "",
                                        multiple: "",
                                      },
                                      model: {
                                        value: document.picForNotification,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            document,
                                            "picForNotification",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "document.picForNotification",
                                      },
                                    },
                                    _vm._l(_vm.usersList, function (user) {
                                      return _c("el-option", {
                                        key: user.id,
                                        attrs: {
                                          label: user.name,
                                          value: String(user.id),
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { lg: "2" } },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: { label: _vm.$t("Contract Template") },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        size: "small",
                                        placeholder: "Select",
                                      },
                                      model: {
                                        value: document.contractTemplate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            document,
                                            "contractTemplate",
                                            $$v
                                          )
                                        },
                                        expression: "document.contractTemplate",
                                      },
                                    },
                                    _vm._l(
                                      _vm.contractTemplateOptions,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item,
                                          attrs: { label: item, value: item },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { lg: "2" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: _vm.$t("Status") } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        size: "small",
                                        placeholder: "Select",
                                      },
                                      model: {
                                        value: document.status,
                                        callback: function ($$v) {
                                          _vm.$set(document, "status", $$v)
                                        },
                                        expression: "document.status",
                                      },
                                    },
                                    _vm._l(
                                      _vm.documentStatusOptions,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item,
                                          attrs: { label: item, value: item },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { lg: "2" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: _vm.$t("Payment Term") } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      size: "small",
                                      type: "number",
                                      min: "0",
                                    },
                                    model: {
                                      value: document.paymentTerm,
                                      callback: function ($$v) {
                                        _vm.$set(document, "paymentTerm", $$v)
                                      },
                                      expression: "document.paymentTerm",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { lg: "2" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: _vm.$t("Deposit") } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      size: "small",
                                      type: "number",
                                      min: "0",
                                    },
                                    model: {
                                      value: document.deposit,
                                      callback: function ($$v) {
                                        _vm.$set(document, "deposit", $$v)
                                      },
                                      expression: "document.deposit",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { lg: "2" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: _vm.$t("Currency") } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        size: "small",
                                        placeholder: "Select",
                                        clearable: "",
                                      },
                                      model: {
                                        value: document.depositCurrency,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            document,
                                            "depositCurrency",
                                            $$v
                                          )
                                        },
                                        expression: "document.depositCurrency",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "HKD", value: "HKD" },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "USD", value: "USD" },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "CNY", value: "CNY" },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "EUR", value: "EUR" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            { attrs: { lg: "2" } },
                            [
                              _c(
                                "b-form-group",
                                { attrs: { label: _vm.$t("Remarks") } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      size: "small",
                                      maxlength: "1000",
                                      placeholder: "Remarks",
                                    },
                                    model: {
                                      value: document.remarks,
                                      callback: function ($$v) {
                                        _vm.$set(document, "remarks", $$v)
                                      },
                                      expression: "document.remarks",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              )
            : _vm._e(),
          _vm.step === 3
            ? _c(
                "div",
                { staticClass: "mt-2" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "previewForm",
                      staticClass: "compact-no-validation",
                      attrs: { model: _vm.row },
                    },
                    [
                      _c(
                        "b-card",
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { lg: "6" } },
                                [
                                  _c("h3", [_vm._v(" Company Detail ")]),
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { lg: "6" } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "Company Name (Invoice)"
                                                ),
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  size: "mini",
                                                  readonly: "readonly",
                                                },
                                                model: {
                                                  value: _vm.row.companyName,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.row,
                                                      "companyName",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "row.companyName",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "Company Name (System)"
                                                ),
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  size: "mini",
                                                  readonly: "readonly",
                                                },
                                                model: {
                                                  value:
                                                    _vm.row.companyNameInternal,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.row,
                                                      "companyNameInternal",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "row.companyNameInternal",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label:
                                                  _vm.$t("Company Address"),
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  size: "mini",
                                                  readonly: "readonly",
                                                },
                                                model: {
                                                  value: _vm.row.companyAddress,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.row,
                                                      "companyAddress",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "row.companyAddress",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "BR Number (For HK Company)"
                                                ),
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  size: "mini",
                                                  readonly: "readonly",
                                                },
                                                model: {
                                                  value: _vm.row.brNumber,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.row,
                                                      "brNumber",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "row.brNumber",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t("Company Type"),
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  size: "mini",
                                                  readonly: "readonly",
                                                },
                                                model: {
                                                  value: _vm.row.companyType,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.row,
                                                      "companyType",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "row.companyType",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "Payment Terms (Days)"
                                                ),
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  size: "mini",
                                                  readonly: "readonly",
                                                },
                                                model: {
                                                  value:
                                                    _vm.row.paymentTermDays,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.row,
                                                      "paymentTermDays",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "row.paymentTermDays",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t("Key Account"),
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  size: "mini",
                                                  readonly: "readonly",
                                                },
                                                model: {
                                                  value: _vm.row.keyAccount,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.row,
                                                      "keyAccount",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "row.keyAccount",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label:
                                                  _vm.$t("Contract End Date"),
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  size: "small",
                                                  readonly: "readonly",
                                                },
                                                model: {
                                                  value:
                                                    _vm.row.contractEndDate,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.row,
                                                      "contractEndDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "row.contractEndDate",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label:
                                                  _vm.$t("Contract Inactive"),
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    clear: "both",
                                                  },
                                                },
                                                [
                                                  _c("el-checkbox", {
                                                    attrs: {
                                                      size: "small",
                                                      disabled: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.row
                                                          .contractEndInactive,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.row,
                                                          "contractEndInactive",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "row.contractEndInactive",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "b-col",
                                        { attrs: { lg: "6" } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label:
                                                  _vm.$t("ERP Account Code"),
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  size: "mini",
                                                  readonly: "readonly",
                                                },
                                                model: {
                                                  value: _vm.row.accountCode,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.row,
                                                      "accountCode",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "row.accountCode",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t("Country"),
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  size: "mini",
                                                  readonly: "readonly",
                                                },
                                                model: {
                                                  value: _vm.row.country,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.row,
                                                      "country",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "row.country",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "Corporate Registration Number"
                                                ),
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  size: "mini",
                                                  readonly: "readonly",
                                                },
                                                model: {
                                                  value:
                                                    _vm.row
                                                      .corporateRegistrationNumber,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.row,
                                                      "corporateRegistrationNumber",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "row.corporateRegistrationNumber",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t("Contract Type"),
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  size: "mini",
                                                  readonly: "readonly",
                                                },
                                                model: {
                                                  value: _vm.row.contractType,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.row,
                                                      "contractType",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "row.contractType",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label:
                                                  _vm.$t("Payment Currency"),
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  size: "mini",
                                                  readonly: "readonly",
                                                },
                                                model: {
                                                  value:
                                                    _vm.row.paymentCurrency,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.row,
                                                      "paymentCurrency",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "row.paymentCurrency",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: { label: _vm.$t("Tags") },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  size: "mini",
                                                  readonly: "readonly",
                                                },
                                                model: {
                                                  value: _vm.row.tags,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.row,
                                                      "tags",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "row.tags",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t("ICP Number"),
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  size: "mini",
                                                  readonly: "readonly",
                                                },
                                                model: {
                                                  value: _vm.row.icpNumber,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.row,
                                                      "icpNumber",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "row.icpNumber",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "Contract End Alert Emails"
                                                ),
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  size: "mini",
                                                  readonly: "readonly",
                                                },
                                                model: {
                                                  value:
                                                    _vm.row
                                                      .contractEndAlertEmails,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.row,
                                                      "contractEndAlertEmails",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "row.contractEndAlertEmails",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t("Credit Limit"),
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  size: "mini",
                                                  readonly: "readonly",
                                                },
                                                model: {
                                                  value: _vm.row.creditAmount,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.row,
                                                      "creditAmount",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "row.creditAmount",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t("Deposit"),
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  size: "mini",
                                                  readonly: "readonly",
                                                },
                                                model: {
                                                  value: _vm.row.deposit,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.row,
                                                      "deposit",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "row.deposit",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("hr"),
                                  _c("h3", [_vm._v(" Company Contacts ")]),
                                  _vm._l(
                                    _vm.row.companyContacts,
                                    function (companyContact, k) {
                                      return _c(
                                        "div",
                                        {
                                          key: "cc" + k,
                                          staticClass: "box-card mb-2",
                                        },
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                { attrs: { lg: "4" } },
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t("Name"),
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "label",
                                                            fn: function (
                                                              scope
                                                            ) {
                                                              return [
                                                                companyContact.isRequired
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "required",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "*"
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "Name"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          size: "mini",
                                                          readonly: "readonly",
                                                        },
                                                        model: {
                                                          value:
                                                            companyContact.name,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              companyContact,
                                                              "name",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "companyContact.name",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "b-col",
                                                { attrs: { lg: "4" } },
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t("Phone"),
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "label",
                                                            fn: function (
                                                              scope
                                                            ) {
                                                              return [
                                                                companyContact.isRequired
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "required",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "*"
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "Phone"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          size: "mini",
                                                          readonly: "readonly",
                                                        },
                                                        model: {
                                                          value:
                                                            companyContact.phone,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              companyContact,
                                                              "phone",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "companyContact.phone",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "b-col",
                                                { attrs: { lg: "4" } },
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t("Email"),
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "label",
                                                            fn: function (
                                                              scope
                                                            ) {
                                                              return [
                                                                companyContact.isRequired
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "required",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "*"
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "Email"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          size: "mini",
                                                          readonly: "readonly",
                                                        },
                                                        model: {
                                                          value:
                                                            companyContact.email,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              companyContact,
                                                              "email",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "companyContact.email",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  _c("hr"),
                                  _c("h3", [_vm._v(" F&A Contacts ")]),
                                  _vm._l(
                                    _vm.row.faContacts,
                                    function (faContact, k) {
                                      return _c(
                                        "div",
                                        {
                                          key: "fc" + k,
                                          staticClass: "box-card mb-2",
                                        },
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                { attrs: { lg: "4" } },
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t("Name"),
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "label",
                                                            fn: function (
                                                              scope
                                                            ) {
                                                              return [
                                                                faContact.isRequired
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "required",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "*"
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "Name"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          size: "mini",
                                                          readonly: "readonly",
                                                        },
                                                        model: {
                                                          value: faContact.name,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              faContact,
                                                              "name",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "faContact.name",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "b-col",
                                                { attrs: { lg: "4" } },
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t("Phone"),
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "label",
                                                            fn: function (
                                                              scope
                                                            ) {
                                                              return [
                                                                faContact.isRequired
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "required",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "*"
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "Phone"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          size: "mini",
                                                          readonly: "readonly",
                                                        },
                                                        model: {
                                                          value:
                                                            faContact.phone,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              faContact,
                                                              "phone",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "faContact.phone",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "b-col",
                                                { attrs: { lg: "4" } },
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t("Email"),
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "label",
                                                            fn: function (
                                                              scope
                                                            ) {
                                                              return [
                                                                faContact.isRequired
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "required",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "*"
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "Email"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          size: "mini",
                                                          readonly: "readonly",
                                                        },
                                                        model: {
                                                          value:
                                                            faContact.email,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              faContact,
                                                              "email",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "faContact.email",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                              _c(
                                "b-col",
                                { attrs: { lg: "6" } },
                                [
                                  _c("h3", [_vm._v(" Documents ")]),
                                  _vm._l(
                                    _vm.row.documents,
                                    function (document, k) {
                                      return _c(
                                        "div",
                                        { key: k },
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                { attrs: { lg: "3" } },
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label:
                                                          _vm.$t(
                                                            "Document Type"
                                                          ),
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "label",
                                                            fn: function (
                                                              scope
                                                            ) {
                                                              return [
                                                                document.isRequired
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "required",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "*"
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "Document Type"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          size: "mini",
                                                          readonly:
                                                            document.isRequired,
                                                          readonly: "readonly",
                                                        },
                                                        model: {
                                                          value: document.type,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              document,
                                                              "type",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "document.type",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "b-col",
                                                { attrs: { lg: "2" } },
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    [
                                                      _c(
                                                        "el-checkbox",
                                                        {
                                                          staticClass: "mt-2",
                                                          attrs: {
                                                            size: "mini",
                                                            disabled:
                                                              "disabled",
                                                          },
                                                          model: {
                                                            value:
                                                              document.isSubsequentDocument,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                document,
                                                                "isSubsequentDocument",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "document.isSubsequentDocument",
                                                          },
                                                        },
                                                        [_vm._v("Subsequent")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass: "text-right",
                                                  attrs: { lg: "5" },
                                                },
                                                [
                                                  _c(
                                                    "b-form-group",
                                                    [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          staticClass:
                                                            "mt-1 text-ellipsis-button",
                                                          attrs: {
                                                            size: "mini",
                                                            readonly:
                                                              "readonly",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.openDocument(
                                                                document
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              document.clientFilename
                                                                ? document.clientFilename
                                                                : "No File"
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c("hr"),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _vm.step === 2
                ? _c(
                    "el-button",
                    {
                      staticStyle: { float: "left" },
                      attrs: {
                        icon: "el-icon-plus",
                        type: "primary",
                        disabled: _vm.isSubmitting,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.addExtraDocument()
                        },
                      },
                    },
                    [_vm._v("Add Extra")]
                  )
                : _vm._e(),
              _vm.step > 0
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        icon: "el-icon-arrow-left",
                        type: "primary",
                        disabled: _vm.isSubmitting,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.previousStep(_vm.step)
                        },
                      },
                    },
                    [_vm._v("Back")]
                  )
                : _vm._e(),
              _vm.step <= 2
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        icon: "el-icon-arrow-right",
                        type: "primary",
                        disabled: _vm.isSubmitting,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.nextStep(_vm.step)
                        },
                      },
                    },
                    [_vm._v("Next")]
                  )
                : _vm._e(),
              _vm.step > 2 || _vm.row.id
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        icon: "el-icon-arrow-right",
                        type: "success",
                        loading: _vm.isSubmitting,
                        disabled: _vm.isSubmitting,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.complete(_vm.step)
                        },
                      },
                    },
                    [_vm._v("Complete")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm.isDebug ? _c("pre", [_vm._v(_vm._s(_vm.row))]) : _vm._e(),
      _c("UploadModal", { ref: "uploadView" }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Document Actions",
            visible: _vm.actionsModalVisible,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.actionsModalVisible = $event
            },
          },
        },
        [
          _vm.currentDocumentIndex !== null
            ? _c("div", [
                _c(
                  "table",
                  { staticStyle: { width: "100%", "table-layout": "fixed" } },
                  [
                    _c("tr", [
                      _c(
                        "th",
                        {
                          staticStyle: {
                            padding: "8px",
                            "text-align": "left",
                            width: "30%",
                          },
                        },
                        [_vm._v("Action Item")]
                      ),
                      _c(
                        "th",
                        {
                          staticStyle: {
                            padding: "8px",
                            "text-align": "left",
                            width: "15%",
                          },
                        },
                        [_vm._v("Status")]
                      ),
                      _c(
                        "th",
                        {
                          staticStyle: {
                            padding: "8px",
                            "text-align": "left",
                            width: "55%",
                          },
                        },
                        [_vm._v("Attachments")]
                      ),
                    ]),
                    _vm._l(_vm.actionTypes, function (action) {
                      return _c("tr", { key: action.key }, [
                        _c(
                          "td",
                          {
                            staticStyle: {
                              padding: "8px",
                              "vertical-align": "top",
                              "word-break": "break-word",
                            },
                          },
                          [_vm._v(_vm._s(action.label))]
                        ),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              padding: "8px",
                              "vertical-align": "top",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { size: "small", placeholder: "Select" },
                                model: {
                                  value:
                                    _vm.row.documents[_vm.currentDocumentIndex][
                                      action.statusField
                                    ],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.row.documents[
                                        _vm.currentDocumentIndex
                                      ],
                                      action.statusField,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "row.documents[currentDocumentIndex][action.statusField]",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "Pending", value: "Pending" },
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: "Uploaded",
                                    value: "Uploaded",
                                  },
                                }),
                                _c("el-option", {
                                  attrs: {
                                    label: "Completed",
                                    value: "Completed",
                                  },
                                }),
                                _c("el-option", {
                                  attrs: { label: "Sent", value: "Sent" },
                                }),
                                _c("el-option", {
                                  attrs: { label: "N/A", value: "N/A" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              padding: "8px",
                              "vertical-align": "top",
                            },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.uploadActionAttachment(
                                      action.key
                                    )
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "el-icon-upload2" }),
                                _vm._v(" Upload File"),
                              ]
                            ),
                            _vm.getActionAttachments(action.key).length > 0
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "margin-top": "8px",
                                      "max-height": "150px",
                                      "overflow-y": "auto",
                                      border: "1px solid #ebeef5",
                                      "border-radius": "4px",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          padding: "8px",
                                          background: "#f5f7fa",
                                          "border-bottom": "1px solid #ebeef5",
                                          "font-size": "12px",
                                          color: "#909399",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " Upload History (" +
                                            _vm._s(
                                              _vm.getActionAttachments(
                                                action.key
                                              ).length
                                            ) +
                                            " files) "
                                        ),
                                      ]
                                    ),
                                    _vm._l(
                                      _vm.getActionAttachments(action.key),
                                      function (file, fileIndex) {
                                        return _c(
                                          "div",
                                          {
                                            key: fileIndex,
                                            staticStyle: {
                                              display: "flex",
                                              "align-items": "center",
                                              padding: "8px",
                                              "border-bottom":
                                                "1px solid #ebeef5",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#909399",
                                                  "font-size": "12px",
                                                  "margin-right": "8px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(fileIndex + 1) + "."
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  content: file.clientFilename,
                                                  placement: "top",
                                                  "open-delay": 300,
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-link",
                                                  {
                                                    staticStyle: {
                                                      flex: "1",
                                                      "min-width": "0",
                                                      overflow: "hidden",
                                                      "text-overflow":
                                                        "ellipsis",
                                                      "white-space": "nowrap",
                                                      display: "block",
                                                    },
                                                    attrs: { type: "primary" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.viewActionAttachment(
                                                          action.key,
                                                          file
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        file.clientFilename
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c("el-button", {
                                              staticStyle: {
                                                "margin-left": "8px",
                                              },
                                              attrs: {
                                                size: "mini",
                                                type: "danger",
                                                icon: "el-icon-delete",
                                                circle: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeActionAttachment(
                                                    action.key,
                                                    fileIndex
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "margin-top": "8px",
                                      "font-size": "12px",
                                      color: "#c0c4cc",
                                    },
                                  },
                                  [_vm._v("No files uploaded")]
                                ),
                          ],
                          1
                        ),
                      ])
                    }),
                  ],
                  2
                ),
              ])
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", disabled: _vm.isSubmitting },
                  on: {
                    click: function ($event) {
                      _vm.actionsModalVisible = false
                    },
                  },
                },
                [_vm._v("Close")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _vm.isSubmitting,
                    disabled: _vm.isSubmitting,
                  },
                  on: { click: _vm.saveActionsAndClose },
                },
                [_vm._v("Confirm")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Share Document",
            visible: _vm.shareModalVisible,
            width: "700px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.shareModalVisible = $event
            },
          },
        },
        [
          _vm.currentShareDocument
            ? _c("div", [
                _c("h4", [
                  _vm._v(
                    'Share "' +
                      _vm._s(_vm.currentShareDocument.type) +
                      '" with other vendors'
                  ),
                ]),
                _vm.outgoingShares.length > 0
                  ? _c(
                      "div",
                      { staticClass: "mb-3" },
                      [
                        _c("h5", [_vm._v("Shared to:")]),
                        _c(
                          "el-table",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { data: _vm.outgoingShares, size: "small" },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "targetCompanyName",
                                label: "Company Name",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "targetAccountCode",
                                label: "Account Code",
                                width: "120",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: { label: "Actions", width: "100" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "danger",
                                              size: "mini",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeShare(
                                                  scope.row.id
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-delete",
                                            }),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                4190243182
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.incomingShares.length > 0
                  ? _c(
                      "div",
                      { staticClass: "mb-3" },
                      [
                        _c("h5", [_vm._v("Shared from:")]),
                        _c(
                          "el-table",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { data: _vm.incomingShares, size: "small" },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "sourceCompanyName",
                                label: "Company Name",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "sourceAccountCode",
                                label: "Account Code",
                                width: "120",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "mt-3" },
                  [
                    _c("h5", [_vm._v("Share with new vendors:")]),
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          multiple: "",
                          filterable: "",
                          remote: "",
                          "reserve-keyword": "",
                          placeholder: "Search and select vendors",
                          "remote-method": _vm.searchProfiles,
                          loading: _vm.searchingProfiles,
                        },
                        model: {
                          value: _vm.selectedShareProfiles,
                          callback: function ($$v) {
                            _vm.selectedShareProfiles = $$v
                          },
                          expression: "selectedShareProfiles",
                        },
                      },
                      _vm._l(_vm.profileSearchResults, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: {
                            label:
                              item.companyName + " (" + item.accountCode + ")",
                            value: item.id,
                            disabled: _vm.isAlreadyShared(item.id),
                          },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.shareModalVisible = false
                    },
                  },
                },
                [_vm._v("Close")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    disabled: _vm.selectedShareProfiles.length === 0,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.shareDocument()
                    },
                  },
                },
                [_vm._v("Share")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }